import React, { FC } from 'react';
import composeFp from 'lodash/fp/compose';
import { NextSeo } from 'next-seo';
import { withApolloData } from '../../services/apolloClient/withApolloData';
import { useNavbarHeight } from '../../components/Navbar/hooks/useNavbarHeight';
import Navbar from '../../components/Navbar/NavbarContainer';
import Container from '../../components/Container/Container';
import { logVisit } from '../../services/visits/logVisit';
import { TerritoryDiscovery } from '../../components/TerritoryDiscovery/TerritoryDiscovery';

type TTerritoryDiscoveryPageProps = {
  searchTerm: string | null;
};

const TerritoryDiscoveryPage: FC<TTerritoryDiscoveryPageProps> = ({ searchTerm }) => {
  const navbarHeight = useNavbarHeight();

  return (
    <>
      <NextSeo title={`Territory discovery${searchTerm ? `: ${searchTerm}` : ''}` || undefined} />
      <div className="min-h-fitScreen bg-white-100">
        <Navbar themeVariant="light" />
        <Container className="md:grid-cols-12 md:gap-x-3" style={{ paddingTop: navbarHeight }}>
          <div className="flex flex-col items-center col-span-full lg:col-start-2 lg:col-span-10">
            <TerritoryDiscovery searchTerm={searchTerm} placement="territoryDiscoveryPage" />
          </div>
        </Container>
      </div>
    </>
  );
};

export default TerritoryDiscoveryPage;

export const getServerSideProps = composeFp(
  withApolloData(TerritoryDiscoveryPage),
  logVisit,
)(async ({ query }) => ({
  props: {
    searchTerm: query?.term || null,
  },
}));
